import { styled } from '@mui/material/styles';
import CheckIcon from '@/assets/checkbox-check.svg?react';
import { FormattedMessage } from 'react-intl';

const GameTileCheckbox = ({
  checked,
  onChange,
  'aria-label': ariaLabel,
}: {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  'aria-label'?: string;
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onChange?.(!checked);
  };

  return (
    <Root
      onClick={handleClick}
      role="checkbox"
      aria-checked={checked}
      aria-label={ariaLabel}
    >
      {checked && <CheckIcon />}
      <Label>
        {checked ? (
          <FormattedMessage id="selected" defaultMessage="Selected" />
        ) : (
          <FormattedMessage id="select" defaultMessage="Select" />
        )}
      </Label>
    </Root>
  );
};

const Root = styled('div')({
  position: 'relative',
  width: 24,
  height: 24,
  border: '2px solid #fff',
  borderRadius: '4px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
});

const Label = styled('div')(({ theme }) => ({
  position: 'absolute',
  fontSize: 10,
  lineHeight: '14px',
  fontWeight: 500,
  color: theme.palette.textPrimaryWhite,
  bottom: -22,
  left: '50%',
  transform: 'translateX(-50%)',
  userSelect: 'none',
}));

export default GameTileCheckbox;
